// extracted by mini-css-extract-plugin
export default {"myTabs":"tabs_myTabs__nE7X1","badge":"tabs_badge__R4TYw","badge-yellow":"tabs_badge-yellow__QpdTI","badge-green":"tabs_badge-green__jjqDQ","badge-red":"tabs_badge-red__lzybK"};